<template>
  <div>
    <dashboard-header></dashboard-header>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <component
            :is="author"
          ></component>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import DashboardHeader from '@/components/dashboard/dashboardHeader'
import Teofilo from '@/components/author/teofilo'
import Kho from '@/components/author/kho'
import Nicodemus from '@/components/author/nicodemus'

export default {
  components: {
    DashboardHeader,
    Teofilo,
    Kho,
    Nicodemus
  },
  created () {
    if (this.author_id === 'teofilo') {
      this.author = Teofilo
    }
    if (this.author_id === 'kho') {
      this.author = Kho
    }
    if (this.author_id === 'nicodemus') {
      this.author = Nicodemus
    }
  },
  data () {
    return {
      author_id: this.$route.params.name
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/author/index.vue